import React, { useState, ChangeEvent } from 'react';
import axios from 'axios';
import downloadIcon from "../../assets/img/downlod.svg";
import { ApiUrl } from '../../config/apiConfig';
import { uploadpdf } from '../../services/Axios/Axios';
import messageService from '../../services/message/messageService';
import Swal from "sweetalert2";
interface UploadResponse {
  success: boolean;
  message: string;
}
const CsvFileCustomer = ({getDataALLs1}:any) => {
  const [file, setFile] = useState<File | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const selectedFile = event.target.files[0];
      setFile(selectedFile);



      const validFileTypes = [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (
        // selectedFile.type === "text/csv" ||
        // selectedFile.name.endsWith(".csv")
        validFileTypes.includes(selectedFile.type) ||
        selectedFile.name.endsWith(".csv") ||
        selectedFile.name.endsWith(".xlsx")
      ) 

    
        
        
        {
        try {
          const response = await uploadpdf(ApiUrl.customerCsvUpload, selectedFile);
          console.log(response.message,"brokerCsvUploadbrokerCsvUpload")
       
          const messageServicesd = messageService();
          messageServicesd.toast(
            "success",
            response.message
          );
          getDataALLs1()
          // if (response.success) {
          //   // setMessage('File uploaded successfully');
          //   setFile(null);
          //   // Optionally call your getData() function here
          //   const messageServicesd = messageService();
          //   messageServicesd.toast(
          //     "success",
          //     response.message
          //   );
          // } else {
          //   setMessage('Upload failed: ' + response.message);
          // }
          if (response.success) {
            setFile(null);
            event.target.value = "";
          } else {
            const messageServicesd = messageService();
            if (response.errors) {
              messageServicesd.toast("success", response.errors);
              event.target.value = "";
            } else {
              messageServicesd.toast("success", response.message);
            }
          }

        } catch (error) {
          setMessage('An error occurred during upload');
          console.error('Error uploading file:', error);
        }
      } else {
        const messageServicesd = messageService();
        messageServicesd.toast(
          "error",
          "Unsupported file type. Please upload a CSV or XLSX file."
        );
      }
    }
  };

  // const triggerFileInput = () => {
  //   const fileInput = document.getElementById('file-input') as HTMLInputElement;
  //   if (fileInput) {
  //     fileInput.click();
  //   }
  // };

  const triggerFileInput = () => {
    Swal.fire({
      title: 'Upload Confirmation',
      text: "You can upload CSV and XLSX files up to 5000 records.",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Upload',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const fileInput = document.getElementById("file-input") as HTMLInputElement;
        if (fileInput) {
          fileInput.click();
        }
      }
    });
  };
  return (
    <div className="rotate h-fit w-[7rem] relative flex items-center">
      <input
        id="file-input"
        type="file"
         className="absolute top-1"
        // accept=".csv"
        accept=".csv, .xlsx"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <img
        src={downloadIcon}
        alt="Download Icon"
        onClick={triggerFileInput}
        style={{ cursor: 'pointer' }}
      />

    </div>
  );
};
export default CsvFileCustomer;
